export const getInvoiceHref = (itemId, skuId) => {
    const qp = skuId ? `?skuId=${skuId}` : '';
    return `/orders/invoice/id-${itemId}${qp}`;
};
